const completedStates = new Set(["completed", "completed_auto", "assumed_completed"]);
const negativeCorrections = new Set(["missed", "not_eaten", "not_taken", "forgotten", "cancelled"]);
const itemId = (item) => item?.schedule_item_id || item?.id;

// Display only. The backend still scores valid missed actions and keeps its audit history.
// An explicit display projection narrows the list; it never resurrects absent live rows.
export function dailyCompletedItems(summary, currentItems, displayItems) {
  const candidates = Array.isArray(displayItems) ? displayItems : summary?.items;
  const applicableIds = new Set((Array.isArray(candidates) ? candidates : []).map(itemId).filter(Boolean));
  const seen = new Set();
  return (Array.isArray(currentItems) ? currentItems : []).filter((item) => {
    const id = itemId(item);
    if (!id || !applicableIds.has(id) || seen.has(id)) return false;
    if (item.historical || item.removed_from_plan || item.deleted_at || item.tombstone || item.is_deleted
        || ["cancelled", "excluded"].includes(item.exception_type)
        || item.applicable === false || item.score_applicable === false
        || negativeCorrections.has(item.correction_type)) return false;
    // Only the server's completed statuses prove completion. A past start time
    // cannot distinguish a changed meal plan from an actually consumed meal.
    if (!completedStates.has(item.status)) return false;
    seen.add(id);
    return true;
  }).map((item) => ({ ...item, schedule_item_id: itemId(item) }));
}
